const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/users/$userId/edit.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/users/$userId/edit")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: ({
    location,
    params
  }) => {
    if (location.pathname === `/admin/system/users/${params.userId}/edit`) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: "/admin/system/users/$userId/edit/general",
        params,
        replace: true
      });
    }
  },
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Edit User",
      description: "Page title"
    })
  }
});